/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssuranceGridDto } from './AssuranceGridDto';
import {
    AssuranceGridDtoFromJSON,
    AssuranceGridDtoFromJSONTyped,
    AssuranceGridDtoToJSON,
} from './AssuranceGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface AssuranceGridDtoPaginatedResults
 */
export interface AssuranceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof AssuranceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<AssuranceGridDto>}
     * @memberof AssuranceGridDtoPaginatedResults
     */
    results?: Array<AssuranceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof AssuranceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the AssuranceGridDtoPaginatedResults interface.
 */
export function instanceOfAssuranceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssuranceGridDtoPaginatedResultsFromJSON(json: any): AssuranceGridDtoPaginatedResults {
    return AssuranceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function AssuranceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssuranceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(AssuranceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function AssuranceGridDtoPaginatedResultsToJSON(value?: AssuranceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(AssuranceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

